import React from "react";

import {
  Card,
  Typography,
  Tooltip,
} from "antd";

import {
  UserAddOutlined,
  ReloadOutlined,
  SolutionOutlined,
  FileSearchOutlined,
} from "@ant-design/icons";

import { motion } from "framer-motion";

const { Text } = Typography;

const YearlyAdmissionOfficialCount = ({ theme }) => {
  const handleRefresh = () => {
    window.dispatchEvent(
      new Event("studentAdmissionUpdated")
    );
  };

  return (
    <motion.div
      initial={{
        opacity: 0,
        y: 10,
      }}
      animate={{
        opacity: 1,
        y: 0,
      }}
      whileHover={{
        y: -5,
        transition: {
          duration: 0.2,
        },
      }}
      style={{
        height: "100%",
      }}
    >
      <Card
        bordered={false}
        style={{
          height: "100%",
          minHeight: 218,
          borderRadius: 22,
          overflow: "hidden",
          position: "relative",
          background: theme.card,
          border: `1px solid ${theme.border}`,
          boxShadow:
            "0 14px 40px rgba(6,42,75,.07)",
        }}
        styles={{
          body: {
            padding: 0,
            height: "100%",
          },
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: 4,
            background:
              "linear-gradient(90deg,#062A4B,#0F6DAB,#4FAE22)",
          }}
        />

        <div
          style={{
            padding: 22,
            height: "100%",
            boxSizing: "border-box",
          }}
        >
          {/* Header */}
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 9,
              }}
            >
              <div
                style={{
                  width: 42,
                  height: 42,
                  borderRadius: 13,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background:
                    "linear-gradient(135deg,#062A4B,#0F6DAB)",
                  color: "#fff",
                  fontSize: 20,
                  boxShadow:
                    "0 7px 18px rgba(6,42,75,.22)",
                }}
              >
                <UserAddOutlined />
              </div>

              <div>
                <Text
                  style={{
                    display: "block",
                    color: theme.text,
                    fontWeight: 700,
                    fontSize: 14,
                  }}
                >
                  Admission Officer
                </Text>

                <Text
                  style={{
                    color: theme.secondary,
                    fontSize: 11,
                  }}
                >
                  Student Enrollment & Records
                </Text>
              </div>
            </div>

            <Tooltip title="Refresh">
              <button
                type="button"
                onClick={handleRefresh}
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 10,
                  border: `1px solid ${theme.border}`,
                  background: theme.soft,
                  color: theme.secondary,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ReloadOutlined />
              </button>
            </Tooltip>
          </div>

          {/* Main Information */}
          <div
            style={{
              marginTop: 18,
              display: "flex",
              alignItems: "flex-start",
              gap: 9,
            }}
          >
            <SolutionOutlined
              style={{
                color: "#0F6DAB",
                fontSize: 20,
                marginTop: 2,
                flexShrink: 0,
              }}
            />

            <Text
              style={{
                color: theme.text,
                fontSize: 15,
                lineHeight: 1.45,
                fontWeight: 700,
              }}
            >
              Manages the school's student admission process.
            </Text>
          </div>

          <Text
            style={{
              display: "block",
              marginTop: 8,
              color: theme.secondary,
              fontSize: 12,
              lineHeight: 1.5,
            }}
          >
            The Admission Officer receives and reviews
            applications, verifies applicant information,
            coordinates enrollment, and maintains accurate
            admission records.
          </Text>

          {/* Responsibilities */}
          <div
            style={{
              marginTop: 16,
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 10,
            }}
          >
            <div
              style={{
                padding: "11px 12px",
                borderRadius: 14,
                background:
                  theme.mode === "dark"
                    ? "rgba(6,42,75,.18)"
                    : "#F4F8FA",
                border: `1px solid ${theme.border}`,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 7,
                }}
              >
                <FileSearchOutlined
                  style={{
                    color: "#062A4B",
                  }}
                />

                <Text
                  style={{
                    color: theme.secondary,
                    fontSize: 11,
                  }}
                >
                  Application Review
                </Text>
              </div>

              <strong
                style={{
                  display: "block",
                  marginTop: 4,
                  color: theme.text,
                  fontSize: 12,
                  lineHeight: 1.35,
                }}
              >
                Verify applications & documents
              </strong>
            </div>

            <div
              style={{
                padding: "11px 12px",
                borderRadius: 14,
                background:
                  theme.mode === "dark"
                    ? "rgba(79,174,34,.12)"
                    : "#F4FAF1",
                border:
                  `1px solid ${
                    theme.mode === "dark"
                      ? "rgba(79,174,34,.25)"
                      : "#DCECCF"
                  }`,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 7,
                }}
              >
                <UserAddOutlined
                  style={{
                    color: "#4FAE22",
                  }}
                />

                <Text
                  style={{
                    color: theme.secondary,
                    fontSize: 11,
                  }}
                >
                  Enrollment
                </Text>
              </div>

              <strong
                style={{
                  display: "block",
                  marginTop: 4,
                  color: theme.text,
                  fontSize: 12,
                  lineHeight: 1.35,
                }}
              >
                Register & enroll approved students
              </strong>
            </div>
          </div>
        </div>
      </Card>
    </motion.div>
  );
};

export default YearlyAdmissionOfficialCount;

